import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appDefaultValue]',
})
export class DefaultValueDirective implements AfterViewChecked {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewChecked() {
    const value = this.el.nativeElement.innerText;
    if (!value || value.trim() === '') {
      this.renderer.setProperty(
        this.el.nativeElement,
        'innerText',
        'No especificado'
      );
    }
  }
}
